export enum DirectionsEnum {
    LEFT = 'left',
    RIGHT = 'right',
}